// src/pages/clients/grm/reports/R0006/configs/KPICard.config.js
/**
 * GRM Client - KPI Card Configuration for R0006 Report
 * 
 * This file contains all GRM-specific theming and configuration
 * for KPI cards used in the R0006 Efficiency & Productivity Report.
 */

export const grmKPIConfig = {
  // Client-specific theme colors
  themes: {
    totalSales: {
      iconColor: '#1976d2',       // GRM Blue
      bgColor: '#e3f2fd'          // Light blue background (optional)
    },
    opportunity: {
      iconColor: '#f57c00',       // GRM Orange  
      bgColor: '#fff3e0'          // Light orange background (optional)
    },
    performance: {
      iconColor: '#388e3c',       // GRM Green
      bgColor: '#e8f5e8'          // Light green background (optional)
    }
  },

  ratings: {
    performance: {
      ranges: [
        { min: 0,  max: 49, color: '#ffffff', bgColor: '#f44336', label: 'Poor' },
        { min: 50, max: 74, color: '#000000', bgColor: '#ff9800', label: 'Fair' },
        { min: 75, max: 89, color: '#ffffff', bgColor: '#4caf50', label: 'Good' },
        { min: 90, max: 100, color: '#ffffff', bgColor: '#2196f3', label: 'Excellent' }
      ]
    },
    
    opportunity: {
      ranges: [
        { min: 0,   max: 3.9, color: '#ffffff', bgColor: '#4caf50', label: 'Optimized' },
        { min: 4,   max: 10,  color: '#000000', bgColor: '#ff9800', label: 'Moderate' },
        { min: 10.1, max: 100, color: '#ffffff', bgColor: '#f44336', label: 'High Priority' }
      ]
    }
    
    // No totalSales rating = 2-line display
  },
  
  // Client-specific formatting preferences
  formatting: {
    currency: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    variance: {
      showSymbol: true,
      decimals: 1,
    }
  },
  
  // Client-specific feature flags
  features: {
    showVariance: true,
    enableHover: true,
    showSubtitles: true,
    animateOnLoad: false
  },
  
  // Custom labels (if client wants different terminology)
  labels: {
    totalSales: "Total Sales",
    opportunity: "Opportunity", 
    performance: "Performance"
  }
};

// Alternative client configuration example
// src/pages/clients/clientB/reports/R0006/configs/KPICard.config.js
export const clientBKPIConfig = {
  themes: {
    totalSales: {
      iconColor: '#d32f2f',       // Red theme
    },
    opportunity: {
      iconColor: '#7b1fa2',       // Purple theme
    },
    performance: {
      iconColor: '#1976d2',       // Blue theme
    }
  },
  
  formatting: {
    currency: {
      minimumFractionDigits: 2,   // ClientB wants decimal places
      maximumFractionDigits: 2,
    }
  },
  
  features: {
    showVariance: false,          // ClientB doesn't want variance shown
    showSubtitles: false,
  },
  
  labels: {
    totalSales: "Revenue",        // ClientB calls it "Revenue"
    opportunity: "Potential",     // Different terminology
    performance: "Score"
  }
};